/**
 * Theme names understood by tokens.css.
 *
 * Adding a theme means adding a `[data-theme="..."]` block to tokens.css and a
 * member here — nothing else. The Tailwind utilities resolve through CSS
 * variables, so no rebuild and no component changes are involved.
 */
export type ThemeName = "light" | "dark" | "high-contrast";

/**
 * Legacy names persisted in localStorage / the preferences stores before the
 * themes were generalised. Mapped rather than migrated so a returning user
 * keeps their choice.
 */
const LEGACY_ALIASES: Record<string, ThemeName> = {
    default: "light",
};

export function normalizeTheme(value: string | null | undefined): ThemeName {
    if (!value) return "light";
    const aliased = LEGACY_ALIASES[value] ?? value;
    return aliased === "dark" || aliased === "high-contrast" ? aliased : "light";
}

/**
 * Point the document at a theme. Everything styled with Tailwind utilities
 * follows immediately; PrimeVue components additionally need their preset
 * swapped by the caller for as long as PrimeVue is in use.
 */
export function applyThemeAttribute(theme: ThemeName): void {
    document.documentElement.dataset.theme = theme;
}
